import { canUseDOM } from './canUseDOM';

const getAppDictionary = () => {
  let dictionary = canUseDOM && document.getElementById('__DICTIONARY_STATE__') || '';
  if (dictionary && dictionary.innerHTML) {
    dictionary = JSON.parse(dictionary.innerHTML) || 'not found';
  }
  return { ...dictionary };
};

export default getAppDictionary;
